/**
 * @desc  在 useContext - dispatch 添加中间件, middleware 从左往右执行
 * @author Kody
 */

export type middlewareFnc<T> = (action: T) => T;

interface IAction {
    type: unknown;
    payload: unknown;
}

export const dispatchWithMiddleware = <T extends IAction>(
    dispatch: React.Dispatch<T>,
    middleWares: Array<middlewareFnc<T>>,
) => {
    // tslint:disable-next-line:only-arrow-functions
    const chain = middleWares.reduce(function (previousValue: middlewareFnc<T>, currentValue: middlewareFnc<T>) {
        // tslint:disable-next-line:only-arrow-functions
        return function () {
            return currentValue(previousValue.apply(undefined, arguments[0]));
        };
    });
    return (value: T) => {
        const enhancedValue = chain(value);
        dispatch(enhancedValue);
    };
};

export const logMiddleWare = <T extends IAction>(action: T) => {
    return action;
};
